module.exports = "<app-header show-fino-logo=\"true\"></app-header>\n\n<div class=\"legal\">\n  <div class=\"markdown\" ng-if=\"vm.markdown\">\n    <div marked=\"vm.markdown\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/legal/legal.html
// module id = 1577
// module chunks = 0